import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Presentazione", href: "#presentazione" },
  { label: "Location", href: "#location" },
  { label: "Servizi", href: "#servizi" },
  { label: "Dicono di noi", href: "#dicono-di-noi" },
  { label: "Gallery", href: "#gallery" },
  { label: "Eventi", href: "#eventi" },
  { label: "Contatti", href: "#contatti" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    window.scrollToSection?.(href);
  };

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 z-50 w-full border-b border-white/10 backdrop-blur-xl transition-colors duration-500 ${
        scrolled ? "bg-[#060607]/90" : "bg-[#060607]/60"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
        <button
          data-testid="navbar-logo"
          onClick={() => go("#top")}
          className="flex items-center gap-2 text-left"
        >
          <img src="/logo.png" alt="Club Tuscolana Star Eventi" className="h-10 w-10 rounded-full" />
          <span className="hidden whitespace-nowrap font-serif text-lg tracking-wide text-linen lg:inline">
            Club Tuscolana <span className="italic text-dusty">Star Eventi</span>
          </span>
        </button>

        <nav className="hidden items-center gap-3 md:flex lg:gap-5" data-testid="navbar-links">
          {links.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              onClick={() => go(l.href)}
              className="whitespace-nowrap text-[10px] font-medium uppercase tracking-[0.15em] text-linen/70 transition-colors duration-300 hover:text-sand lg:text-xs lg:tracking-[0.18em]"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-cta-preventivo"
            onClick={() => go("#contatti")}
            className="rounded-full border border-sand/60 px-5 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-sand transition-all duration-300 hover:bg-sand hover:text-white"
          >
            Preventivo
          </button>
        </nav>

        <button
          data-testid="navbar-mobile-menu-button"
          className="text-linen md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label="Apri menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-white/10 bg-[#060607]/95 px-6 py-6 md:hidden" data-testid="navbar-mobile-menu">
          <div className="flex flex-col gap-5">
            {links.map((l) => (
              <button
                key={l.href}
                data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                onClick={() => go(l.href)}
                className="text-left font-serif text-2xl text-linen transition-colors hover:text-sand"
              >
                {l.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
